import View from './View.vue';

export default {
	View,
}
